import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Témoignages" title="Ce qu'en disent ceux qui l'utilisent" width="narrow" data-id="element-253" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-4xl divide-y divide-blue-200/70" data-id="element-254" data-mp="3azj9dk7whw5v">
        {testimonials.map(item => <li key={item.author} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-255" data-mp="370kaohcrivmv">
            <div className="flex items-start gap-3" data-id="element-256" data-mp="2x09xgwqq9o7p">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-257" data-mp="2x11pxyp135tr">
                {item.initials}
              </span>
              <span data-id="element-258" data-mp="v8ncpcxfipjo">
                <span className="flex gap-0.5" aria-label="5 étoiles sur 5" data-id="element-259" data-mp="v72hdl3aj2kr">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-260" data-mp="h4wvo4o4mgj9" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-261" data-mp="79v6x9xrjgh7">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-262" data-mp="zw65kf1t77bd">{item.role}</span>
                {item.city && <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-263" data-mp="14uhiiynehxxt">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-264" data-mp="q5lb93t64oy9" />
                    {item.city}
                  </span>}
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-265" data-mp="1iv1yln1xlfnm">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}